// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmartGoalPopup-module__font-s-10___KmyEt {
  font-size: 10px !important;
}

.SmartGoalPopup-module__font-s-12___g1Fqy {
  font-size: 12px !important;
}

.SmartGoalPopup-module__font-s-13___TOK7a {
  font-size: 13px !important;
}

.SmartGoalPopup-module__font-s-14___VfRqq {
  font-size: 14px !important;
}

.SmartGoalPopup-module__font-s-15___cuYGG {
  font-size: 15px !important;
}

.SmartGoalPopup-module__font-s-16___Lp0p_ {
  font-size: 16px !important;
}

.SmartGoalPopup-module__font-s-18___msSbL {
  font-size: 18px !important;
}

.SmartGoalPopup-module__font-s-20___vuISe {
  font-size: 20px !important;
}

.SmartGoalPopup-module__font-s-22____m2R5 {
  font-size: 22px !important;
}

.SmartGoalPopup-module__font-s-28___RHGoB {
  font-size: 28px !important;
}

.SmartGoalPopup-module__font-w-400___r2R2y {
  font-weight: 400 !important;
}

.SmartGoalPopup-module__font-w-500___moyAe {
  font-weight: 500 !important;
}

.SmartGoalPopup-module__font-w-600___bGQmU {
  font-weight: 600 !important;
}

.SmartGoalPopup-module__font-w-700___MPvzV {
  font-weight: 700 !important;
}

.SmartGoalPopup-module__p-5___gDJld {
  padding: 5px !important;
}

.SmartGoalPopup-module__p-12___m9jPF {
  padding: 12px !important;
}

.SmartGoalPopup-module__p-16___frDaT {
  padding: 16px !important;
}

.SmartGoalPopup-module__p-30___rXriB {
  padding: 30px !important;
}

.SmartGoalPopup-module__p-b-0___RbNwH {
  padding-bottom: 0 !important;
}

.SmartGoalPopup-module__p-b-5___OUISW {
  padding-bottom: 5px !important;
}

.SmartGoalPopup-module__p-b-10___yv1Tz {
  padding-bottom: 10px !important;
}

.SmartGoalPopup-module__p-b-12___Y2Doz {
  padding-bottom: 12px !important;
}

.SmartGoalPopup-module__p-b-16___lQG2R {
  padding-bottom: 16px !important;
}

.SmartGoalPopup-module__p-b-18___PHXSl {
  padding-bottom: 18px !important;
}

.SmartGoalPopup-module__p-b-20___hUDcy {
  padding-bottom: 20px !important;
}

.SmartGoalPopup-module__p-b-25___x3YRA {
  padding-bottom: 25px !important;
}

.SmartGoalPopup-module__p-b-30___GN1Cs {
  padding-bottom: 30px !important;
}

.SmartGoalPopup-module__p-b-50___h7H5m {
  padding-bottom: 50px !important;
}

.SmartGoalPopup-module__p-t-0___vMpnC {
  padding-top: 0 !important;
}

.SmartGoalPopup-module__p-t-12___yfpa8 {
  padding-top: 12px !important;
}

.SmartGoalPopup-module__p-t-16___k4f65 {
  padding-top: 16px !important;
}

.SmartGoalPopup-module__p-t-18___tU6sh {
  padding-top: 18px !important;
}

.SmartGoalPopup-module__p-t-20___VI5Q4 {
  padding-top: 20px !important;
}

.SmartGoalPopup-module__p-t-30___QQkLd {
  padding-top: 30px !important;
}

.SmartGoalPopup-module__p-t-40___mYnwG {
  padding-top: 40px !important;
}

.SmartGoalPopup-module__p-t-50___a9WXv {
  padding-top: 50px !important;
}

.SmartGoalPopup-module__p-l-20___HjSQj {
  padding-left: 20px !important;
}

.SmartGoalPopup-module__p-l-30___D8hzq {
  padding-left: 30px !important;
}

.SmartGoalPopup-module__p-l-40___TveLj {
  padding-left: 40px !important;
}

.SmartGoalPopup-module__p-r-16___duVSM {
  padding-right: 16px !important;
}

.SmartGoalPopup-module__p-r-20___LdeVi {
  padding-right: 20px !important;
}

.SmartGoalPopup-module__p-r-30___TQCnw {
  padding-right: 30px !important;
}

.SmartGoalPopup-module__p-r-50___U7STf {
  padding-right: 50px !important;
}

.SmartGoalPopup-module__p-r-60___FCTPo {
  padding-right: 60px !important;
}

.SmartGoalPopup-module__m-b-1___DUYtv {
  margin-bottom: 1px !important;
}

.SmartGoalPopup-module__m-b-2___HCvAw {
  margin-bottom: 2px !important;
}

.SmartGoalPopup-module__m-b-6___l6bEg {
  margin-bottom: 6px !important;
}

.SmartGoalPopup-module__m-b-8___sw4NA {
  margin-bottom: 8px !important;
}

.SmartGoalPopup-module__m-b-10___vTglY {
  margin-bottom: 10px !important;
}

.SmartGoalPopup-module__m-b-14___iaDX0 {
  margin-bottom: 14px !important;
}

.SmartGoalPopup-module__m-b-16___FGP2p {
  margin-bottom: 16px !important;
}

.SmartGoalPopup-module__m-b-20___N0XSR {
  margin-bottom: 20px !important;
}

.SmartGoalPopup-module__m-b-22___hTiBx {
  margin-bottom: 22px !important;
}

.SmartGoalPopup-module__m-b-24___pS1AZ {
  margin-bottom: 24px !important;
}

.SmartGoalPopup-module__m-b-30___lFJN2 {
  margin-bottom: 30px !important;
}

.SmartGoalPopup-module__m-b-32___K5qOv {
  margin-bottom: 32px !important;
}

.SmartGoalPopup-module__m-b-40___uzBS3 {
  margin-bottom: 40px !important;
}

.SmartGoalPopup-module__m-t-2___HltQ3 {
  margin-top: 2px !important;
}

.SmartGoalPopup-module__m-t-3___H54C0 {
  margin-top: 3px !important;
}

.SmartGoalPopup-module__m-t-4___FHJM_ {
  margin-top: 4px !important;
}

.SmartGoalPopup-module__m-t-5___XAHnG {
  margin-top: 5px !important;
}

.SmartGoalPopup-module__m-t-8___G4kVP {
  margin-top: 8px !important;
}

.SmartGoalPopup-module__m-t-10___tjL4V {
  margin-top: 10px !important;
}

.SmartGoalPopup-module__m-t-15___qvcgT {
  margin-top: 15px !important;
}

.SmartGoalPopup-module__m-t-16___HkcNy {
  margin-top: 16px !important;
}

.SmartGoalPopup-module__m-t-20___N9Vo4 {
  margin-top: 20px !important;
}

.SmartGoalPopup-module__m-t-22___hUoVs {
  margin-top: 22px !important;
}

.SmartGoalPopup-module__m-t-30___QuQZH {
  margin-top: 30px !important;
}

.SmartGoalPopup-module__m-t-32___mKFub {
  margin-top: 32px !important;
}

.SmartGoalPopup-module__m-l-auto___ppdJo {
  margin-left: auto !important;
}

.SmartGoalPopup-module__m-l-4___etdRO {
  margin-left: 4px !important;
}

.SmartGoalPopup-module__m-l-5___UFYFQ {
  margin-left: 5px !important;
}

.SmartGoalPopup-module__m-l-6___Xzlyu {
  margin-left: 6px !important;
}

.SmartGoalPopup-module__m-l-8___M_ra0 {
  margin-left: 8px !important;
}

.SmartGoalPopup-module__m-l-10___Fea0S {
  margin-left: 10px !important;
}

.SmartGoalPopup-module__m-l-16___i2vV1 {
  margin-left: 16px !important;
}

.SmartGoalPopup-module__m-l-20___FnJ8e {
  margin-left: 20px !important;
}

.SmartGoalPopup-module__m-l-24___w5zdf {
  margin-left: 24px !important;
}

.SmartGoalPopup-module__m-l-30___ahfpe {
  margin-left: 30px !important;
}

.SmartGoalPopup-module__m-l-35___T6pEL {
  margin-left: 35px !important;
}

.SmartGoalPopup-module__m-l-40___Thlbp {
  margin-left: 40px !important;
}

.SmartGoalPopup-module__m-r-8___mZqj1 {
  margin-right: 8px !important;
}

.SmartGoalPopup-module__m-r-10___oXfe7 {
  margin-right: 10px !important;
}

.SmartGoalPopup-module__m-r-16___HQZwP {
  margin-right: 16px !important;
}

.SmartGoalPopup-module__m-r-20___M_EKR {
  margin-right: 20px !important;
}

.SmartGoalPopup-module__m-r-24___Chplg {
  margin-right: 24px !important;
}

.SmartGoalPopup-module__m-r-30___dMqsN {
  margin-right: 30px !important;
}

.SmartGoalPopup-module__m-r-40___Xnf_W {
  margin-right: 40px !important;
}

.SmartGoalPopup-module__border-r-3___L2iTj {
  border-radius: 3px !important;
}

.SmartGoalPopup-module__border-r-4___bY6dT {
  border-radius: 4px !important;
}

.SmartGoalPopup-module__border-r-6___fSVtH {
  border-radius: 6px !important;
}

.SmartGoalPopup-module__border-r-10___bBrqH {
  border-radius: 10px !important;
}

.SmartGoalPopup-module__border-r-12___sxCG6 {
  border-radius: 12px !important;
}

.SmartGoalPopup-module__border-r-16___xqEWq {
  border-radius: 16px !important;
}

.SmartGoalPopup-module__border-r-50___hMUX3 {
  border-radius: 50% !important;
}

.SmartGoalPopup-module__primary-border___Sch0r {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SmartGoalPopup-module__primary-border-b___Lf1C9 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SmartGoalPopup-module__primary-border-t___ng1rI {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SmartGoalPopup-module__primary-border-l___TbgU1 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SmartGoalPopup-module__primary-border-r___onfwn {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SmartGoalPopup-module__secondary-border___bOkVJ {
  border: 1px solid #637768;
}

.SmartGoalPopup-module__secondary-border-b___r22HF {
  border-bottom: 1px solid #637768;
}

.SmartGoalPopup-module__secondary-border-t___G_iwb {
  border-top: 1px solid #637768;
}

.SmartGoalPopup-module__secondary-border-l___V6HGS {
  border-left: 1px solid #637768;
}

.SmartGoalPopup-module__secondary-border-r___wszer {
  border-right: 1px solid #637768;
}

.SmartGoalPopup-module__gap-0___DFPE4 {
  gap: 0 !important;
}

.SmartGoalPopup-module__gap-2___wr9hu {
  gap: 2px !important;
}

.SmartGoalPopup-module__gap-4___z4boE {
  gap: 4px !important;
}

.SmartGoalPopup-module__gap-5___xhePU {
  gap: 5px !important;
}

.SmartGoalPopup-module__gap-6___VhWBJ {
  gap: 6px !important;
}

.SmartGoalPopup-module__gap-8___Ut4dz {
  gap: 8px !important;
}

.SmartGoalPopup-module__gap-10___gd6mB {
  gap: 10px !important;
}

.SmartGoalPopup-module__gap-12___nQakv {
  gap: 12px !important;
}

.SmartGoalPopup-module__gap-14___yEfIb {
  gap: 14px !important;
}

.SmartGoalPopup-module__gap-16___N6PxD {
  gap: 16px !important;
}

.SmartGoalPopup-module__gap-18___twbkG {
  gap: 18px !important;
}

.SmartGoalPopup-module__gap-20___Z9y49 {
  gap: 20px !important;
}

.SmartGoalPopup-module__gap-24___Wp1rZ {
  gap: 24px !important;
}

.SmartGoalPopup-module__gap-26___B_8oY {
  gap: 26px !important;
}

.SmartGoalPopup-module__gap-30___OxXh2 {
  gap: 30px !important;
}

.SmartGoalPopup-module__gap-32___GS1pz {
  gap: 32px !important;
}

.SmartGoalPopup-module__gap-40___q7M9Z {
  gap: 40px !important;
}

.SmartGoalPopup-module__gap-50___b7Qi0 {
  gap: 50px !important;
}

.SmartGoalPopup-module__flex-1___nLoa2 {
  flex: 1;
}

.SmartGoalPopup-module__flex-none___EsyFF {
  flex: none !important;
}

.SmartGoalPopup-module__flex-column___HYCj3 {
  display: flex;
  flex-direction: column !important;
}

.SmartGoalPopup-module__flex-row___Pv8pp {
  display: flex;
  flex-direction: row !important;
}

.SmartGoalPopup-module__vertically-centered___y4zHE {
  display: flex;
  align-items: center !important;
}

.SmartGoalPopup-module__horizontally-centered___FPM5f {
  display: flex;
  justify-content: center !important;
}

.SmartGoalPopup-module__horizontally-end___Lf0mK {
  display: flex;
  justify-content: end !important;
}

.SmartGoalPopup-module__vertically-start___A4cVF {
  display: flex;
  align-items: start !important;
}

.SmartGoalPopup-module__space-between___K8z6f {
  display: flex;
  justify-content: space-between !important;
}

.SmartGoalPopup-module__flex-wrap___mofS7 {
  flex-wrap: wrap !important;
}

.SmartGoalPopup-module__height-100___NBdUC {
  height: 100%;
}

.SmartGoalPopup-module__width-50___E137w {
  width: 50% !important;
}

.SmartGoalPopup-module__width-100___X_XEW {
  width: 100%;
}

.SmartGoalPopup-module__cursor-pointer___wF1Tu {
  cursor: pointer;
}

.SmartGoalPopup-module__cursor-not-allowed___D1brE {
  cursor: not-allowed !important;
}

.SmartGoalPopup-module__absolute-centered___A1tPU {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SmartGoalPopup-module__absolute___tRJZr {
  position: absolute;
}

.SmartGoalPopup-module__relative___q4qmF {
  position: relative;
}

.SmartGoalPopup-module__fixed___Hobrf {
  position: fixed;
}

.SmartGoalPopup-module__visible___ZEfRv {
  opacity: 1;
}

.SmartGoalPopup-module__invisible___s8hMS {
  opacity: 0;
}

.SmartGoalPopup-module__col-90___aYDod {
  width: 90% !important;
}

.SmartGoalPopup-module__col-auto___Gqolv {
  width: auto !important;
}

.SmartGoalPopup-module__medical-tabs___oZRDW {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SmartGoalPopup-module__medical-table-new___h1n3F {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SmartGoalPopup-module__medical-table-new___h1n3F:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SmartGoalPopup-module__medical-table-new___h1n3F::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SmartGoalPopup-module__medical-table-new___h1n3F::-webkit-scrollbar-track {
  display: none;
}
.SmartGoalPopup-module__medical-table-new___h1n3F.SmartGoalPopup-module__no-pagination___oJP7x {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SmartGoalPopup-module__medical-table-new___h1n3F.SmartGoalPopup-module__no-pagination___oJP7x:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SmartGoalPopup-module__medical-table-new___h1n3F.SmartGoalPopup-module__no-pagination___oJP7x::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SmartGoalPopup-module__medical-table-new___h1n3F.SmartGoalPopup-module__no-pagination___oJP7x::-webkit-scrollbar-track {
  display: none;
}

.SmartGoalPopup-module__medical-table-empty___TEf2x {
  padding: 14px 40px !important;
}

.SmartGoalPopup-module__icon-btn___DkvlM {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SmartGoalPopup-module__search-icon___XBYJS {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SmartGoalPopup-module__disable-select___gzxew {
  user-select: none;
}

.SmartGoalPopup-module__break-word___Nd_UT {
  word-break: break-word;
}

.SmartGoalPopup-module__popup-clear-btn___NymVR {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SmartGoalPopup-module__scroll-m-b-20___xAORn {
  scroll-margin-bottom: 20px;
}

.SmartGoalPopup-module__container___CswUi {
  flex: 1;
  padding: 30px;
}
.SmartGoalPopup-module__container___CswUi .SmartGoalPopup-module__title___ywNw5 {
  font-family: var(--font-family);
  font-weight: 700;
}
.SmartGoalPopup-module__container___CswUi .SmartGoalPopup-module__label___sQJTq {
  font-family: var(--font-family);
  font-weight: 500;
  margin: 2em 0 0.5em 0;
}
.SmartGoalPopup-module__container___CswUi .SmartGoalPopup-module__checkboxes___OKlXb {
  display: flex;
  flex-wrap: wrap;
}
.SmartGoalPopup-module__container___CswUi .SmartGoalPopup-module__checkboxes___OKlXb .SmartGoalPopup-module__checkbox___P30aK {
  width: 26%;
}
.SmartGoalPopup-module__container___CswUi .SmartGoalPopup-module__select___JgXtv {
  width: 48%;
}
.SmartGoalPopup-module__container___CswUi .SmartGoalPopup-module__dates___wHYQj {
  display: flex;
}
.SmartGoalPopup-module__container___CswUi .SmartGoalPopup-module__buttonsContainer___Q14MR {
  flex: 1;
  gap: 24px;
  display: flex;
  margin-top: 62px;
  flex-direction: row;
  justify-content: end;
}
.SmartGoalPopup-module__container___CswUi .SmartGoalPopup-module__buttonsContainer___Q14MR .SmartGoalPopup-module__button___N7jST {
  width: 160px;
  height: 40px;
}
.SmartGoalPopup-module__container___CswUi .SmartGoalPopup-module__buttonsContainerRedesigned___fV0tM {
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding-top: 25px;
  gap: 16px;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/SmartGoalPopup/SmartGoalPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;EACA,aAAA;AA8pBF;AA5pBE;EEoBA,+BApBO;EAqBP,gBCtBK;AHiqBP;AA5pBE;EEgBA,+BApBO;EAqBP,gBCxBO;EHSL,qBAAA;AA+pBJ;AA5pBE;EACE,aAAA;EACA,eAAA;AA8pBJ;AA5pBI;EACE,UAAA;AA8pBN;AA1pBE;EACE,UAAA;AA4pBJ;AAzpBE;EACE,aAAA;AA2pBJ;AAxpBE;EACE,OAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AA0pBJ;AAxpBI;EACE,YAAA;EACA,YAAA;AA0pBN;AAtpBE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,SAAA;EACA,2CAAA;AAwpBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n  padding: 30px;\n\n  .title {\n    @include get-font($roboto, $bold);\n  }\n\n  .label {\n    @include get-font($roboto, $medium, $medium);\n    margin: 2em 0 0.5em 0;\n  }\n\n  .checkboxes {\n    display: flex;\n    flex-wrap: wrap;\n\n    .checkbox {\n      width: 26%;\n    }\n  }\n\n  .select {\n    width: 48%;\n  }\n\n  .dates {\n    display: flex;\n  }\n\n  .buttonsContainer {\n    flex: 1;\n    gap: 24px;\n    display: flex;\n    margin-top: 62px;\n    flex-direction: row;\n    justify-content: end;\n\n    .button {\n      width: 160px;\n      height: 40px;\n    }\n  }\n\n  .buttonsContainerRedesigned {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    padding-top: 25px;\n    gap: 16px;\n    border-top: 1px solid rgba(91, 91, 91, 0.2);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SmartGoalPopup-module__font-s-10___KmyEt`,
	"fontS12": `SmartGoalPopup-module__font-s-12___g1Fqy`,
	"fontS13": `SmartGoalPopup-module__font-s-13___TOK7a`,
	"fontS14": `SmartGoalPopup-module__font-s-14___VfRqq`,
	"fontS15": `SmartGoalPopup-module__font-s-15___cuYGG`,
	"fontS16": `SmartGoalPopup-module__font-s-16___Lp0p_`,
	"fontS18": `SmartGoalPopup-module__font-s-18___msSbL`,
	"fontS20": `SmartGoalPopup-module__font-s-20___vuISe`,
	"fontS22": `SmartGoalPopup-module__font-s-22____m2R5`,
	"fontS28": `SmartGoalPopup-module__font-s-28___RHGoB`,
	"fontW400": `SmartGoalPopup-module__font-w-400___r2R2y`,
	"fontW500": `SmartGoalPopup-module__font-w-500___moyAe`,
	"fontW600": `SmartGoalPopup-module__font-w-600___bGQmU`,
	"fontW700": `SmartGoalPopup-module__font-w-700___MPvzV`,
	"p5": `SmartGoalPopup-module__p-5___gDJld`,
	"p12": `SmartGoalPopup-module__p-12___m9jPF`,
	"p16": `SmartGoalPopup-module__p-16___frDaT`,
	"p30": `SmartGoalPopup-module__p-30___rXriB`,
	"pB0": `SmartGoalPopup-module__p-b-0___RbNwH`,
	"pB5": `SmartGoalPopup-module__p-b-5___OUISW`,
	"pB10": `SmartGoalPopup-module__p-b-10___yv1Tz`,
	"pB12": `SmartGoalPopup-module__p-b-12___Y2Doz`,
	"pB16": `SmartGoalPopup-module__p-b-16___lQG2R`,
	"pB18": `SmartGoalPopup-module__p-b-18___PHXSl`,
	"pB20": `SmartGoalPopup-module__p-b-20___hUDcy`,
	"pB25": `SmartGoalPopup-module__p-b-25___x3YRA`,
	"pB30": `SmartGoalPopup-module__p-b-30___GN1Cs`,
	"pB50": `SmartGoalPopup-module__p-b-50___h7H5m`,
	"pT0": `SmartGoalPopup-module__p-t-0___vMpnC`,
	"pT12": `SmartGoalPopup-module__p-t-12___yfpa8`,
	"pT16": `SmartGoalPopup-module__p-t-16___k4f65`,
	"pT18": `SmartGoalPopup-module__p-t-18___tU6sh`,
	"pT20": `SmartGoalPopup-module__p-t-20___VI5Q4`,
	"pT30": `SmartGoalPopup-module__p-t-30___QQkLd`,
	"pT40": `SmartGoalPopup-module__p-t-40___mYnwG`,
	"pT50": `SmartGoalPopup-module__p-t-50___a9WXv`,
	"pL20": `SmartGoalPopup-module__p-l-20___HjSQj`,
	"pL30": `SmartGoalPopup-module__p-l-30___D8hzq`,
	"pL40": `SmartGoalPopup-module__p-l-40___TveLj`,
	"pR16": `SmartGoalPopup-module__p-r-16___duVSM`,
	"pR20": `SmartGoalPopup-module__p-r-20___LdeVi`,
	"pR30": `SmartGoalPopup-module__p-r-30___TQCnw`,
	"pR50": `SmartGoalPopup-module__p-r-50___U7STf`,
	"pR60": `SmartGoalPopup-module__p-r-60___FCTPo`,
	"mB1": `SmartGoalPopup-module__m-b-1___DUYtv`,
	"mB2": `SmartGoalPopup-module__m-b-2___HCvAw`,
	"mB6": `SmartGoalPopup-module__m-b-6___l6bEg`,
	"mB8": `SmartGoalPopup-module__m-b-8___sw4NA`,
	"mB10": `SmartGoalPopup-module__m-b-10___vTglY`,
	"mB14": `SmartGoalPopup-module__m-b-14___iaDX0`,
	"mB16": `SmartGoalPopup-module__m-b-16___FGP2p`,
	"mB20": `SmartGoalPopup-module__m-b-20___N0XSR`,
	"mB22": `SmartGoalPopup-module__m-b-22___hTiBx`,
	"mB24": `SmartGoalPopup-module__m-b-24___pS1AZ`,
	"mB30": `SmartGoalPopup-module__m-b-30___lFJN2`,
	"mB32": `SmartGoalPopup-module__m-b-32___K5qOv`,
	"mB40": `SmartGoalPopup-module__m-b-40___uzBS3`,
	"mT2": `SmartGoalPopup-module__m-t-2___HltQ3`,
	"mT3": `SmartGoalPopup-module__m-t-3___H54C0`,
	"mT4": `SmartGoalPopup-module__m-t-4___FHJM_`,
	"mT5": `SmartGoalPopup-module__m-t-5___XAHnG`,
	"mT8": `SmartGoalPopup-module__m-t-8___G4kVP`,
	"mT10": `SmartGoalPopup-module__m-t-10___tjL4V`,
	"mT15": `SmartGoalPopup-module__m-t-15___qvcgT`,
	"mT16": `SmartGoalPopup-module__m-t-16___HkcNy`,
	"mT20": `SmartGoalPopup-module__m-t-20___N9Vo4`,
	"mT22": `SmartGoalPopup-module__m-t-22___hUoVs`,
	"mT30": `SmartGoalPopup-module__m-t-30___QuQZH`,
	"mT32": `SmartGoalPopup-module__m-t-32___mKFub`,
	"mLAuto": `SmartGoalPopup-module__m-l-auto___ppdJo`,
	"mL4": `SmartGoalPopup-module__m-l-4___etdRO`,
	"mL5": `SmartGoalPopup-module__m-l-5___UFYFQ`,
	"mL6": `SmartGoalPopup-module__m-l-6___Xzlyu`,
	"mL8": `SmartGoalPopup-module__m-l-8___M_ra0`,
	"mL10": `SmartGoalPopup-module__m-l-10___Fea0S`,
	"mL16": `SmartGoalPopup-module__m-l-16___i2vV1`,
	"mL20": `SmartGoalPopup-module__m-l-20___FnJ8e`,
	"mL24": `SmartGoalPopup-module__m-l-24___w5zdf`,
	"mL30": `SmartGoalPopup-module__m-l-30___ahfpe`,
	"mL35": `SmartGoalPopup-module__m-l-35___T6pEL`,
	"mL40": `SmartGoalPopup-module__m-l-40___Thlbp`,
	"mR8": `SmartGoalPopup-module__m-r-8___mZqj1`,
	"mR10": `SmartGoalPopup-module__m-r-10___oXfe7`,
	"mR16": `SmartGoalPopup-module__m-r-16___HQZwP`,
	"mR20": `SmartGoalPopup-module__m-r-20___M_EKR`,
	"mR24": `SmartGoalPopup-module__m-r-24___Chplg`,
	"mR30": `SmartGoalPopup-module__m-r-30___dMqsN`,
	"mR40": `SmartGoalPopup-module__m-r-40___Xnf_W`,
	"borderR3": `SmartGoalPopup-module__border-r-3___L2iTj`,
	"borderR4": `SmartGoalPopup-module__border-r-4___bY6dT`,
	"borderR6": `SmartGoalPopup-module__border-r-6___fSVtH`,
	"borderR10": `SmartGoalPopup-module__border-r-10___bBrqH`,
	"borderR12": `SmartGoalPopup-module__border-r-12___sxCG6`,
	"borderR16": `SmartGoalPopup-module__border-r-16___xqEWq`,
	"borderR50": `SmartGoalPopup-module__border-r-50___hMUX3`,
	"primaryBorder": `SmartGoalPopup-module__primary-border___Sch0r`,
	"primaryBorderB": `SmartGoalPopup-module__primary-border-b___Lf1C9`,
	"primaryBorderT": `SmartGoalPopup-module__primary-border-t___ng1rI`,
	"primaryBorderL": `SmartGoalPopup-module__primary-border-l___TbgU1`,
	"primaryBorderR": `SmartGoalPopup-module__primary-border-r___onfwn`,
	"secondaryBorder": `SmartGoalPopup-module__secondary-border___bOkVJ`,
	"secondaryBorderB": `SmartGoalPopup-module__secondary-border-b___r22HF`,
	"secondaryBorderT": `SmartGoalPopup-module__secondary-border-t___G_iwb`,
	"secondaryBorderL": `SmartGoalPopup-module__secondary-border-l___V6HGS`,
	"secondaryBorderR": `SmartGoalPopup-module__secondary-border-r___wszer`,
	"gap0": `SmartGoalPopup-module__gap-0___DFPE4`,
	"gap2": `SmartGoalPopup-module__gap-2___wr9hu`,
	"gap4": `SmartGoalPopup-module__gap-4___z4boE`,
	"gap5": `SmartGoalPopup-module__gap-5___xhePU`,
	"gap6": `SmartGoalPopup-module__gap-6___VhWBJ`,
	"gap8": `SmartGoalPopup-module__gap-8___Ut4dz`,
	"gap10": `SmartGoalPopup-module__gap-10___gd6mB`,
	"gap12": `SmartGoalPopup-module__gap-12___nQakv`,
	"gap14": `SmartGoalPopup-module__gap-14___yEfIb`,
	"gap16": `SmartGoalPopup-module__gap-16___N6PxD`,
	"gap18": `SmartGoalPopup-module__gap-18___twbkG`,
	"gap20": `SmartGoalPopup-module__gap-20___Z9y49`,
	"gap24": `SmartGoalPopup-module__gap-24___Wp1rZ`,
	"gap26": `SmartGoalPopup-module__gap-26___B_8oY`,
	"gap30": `SmartGoalPopup-module__gap-30___OxXh2`,
	"gap32": `SmartGoalPopup-module__gap-32___GS1pz`,
	"gap40": `SmartGoalPopup-module__gap-40___q7M9Z`,
	"gap50": `SmartGoalPopup-module__gap-50___b7Qi0`,
	"flex1": `SmartGoalPopup-module__flex-1___nLoa2`,
	"flexNone": `SmartGoalPopup-module__flex-none___EsyFF`,
	"flexColumn": `SmartGoalPopup-module__flex-column___HYCj3`,
	"flexRow": `SmartGoalPopup-module__flex-row___Pv8pp`,
	"verticallyCentered": `SmartGoalPopup-module__vertically-centered___y4zHE`,
	"horizontallyCentered": `SmartGoalPopup-module__horizontally-centered___FPM5f`,
	"horizontallyEnd": `SmartGoalPopup-module__horizontally-end___Lf0mK`,
	"verticallyStart": `SmartGoalPopup-module__vertically-start___A4cVF`,
	"spaceBetween": `SmartGoalPopup-module__space-between___K8z6f`,
	"flexWrap": `SmartGoalPopup-module__flex-wrap___mofS7`,
	"height100": `SmartGoalPopup-module__height-100___NBdUC`,
	"width50": `SmartGoalPopup-module__width-50___E137w`,
	"width100": `SmartGoalPopup-module__width-100___X_XEW`,
	"cursorPointer": `SmartGoalPopup-module__cursor-pointer___wF1Tu`,
	"cursorNotAllowed": `SmartGoalPopup-module__cursor-not-allowed___D1brE`,
	"absoluteCentered": `SmartGoalPopup-module__absolute-centered___A1tPU`,
	"absolute": `SmartGoalPopup-module__absolute___tRJZr`,
	"relative": `SmartGoalPopup-module__relative___q4qmF`,
	"fixed": `SmartGoalPopup-module__fixed___Hobrf`,
	"visible": `SmartGoalPopup-module__visible___ZEfRv`,
	"invisible": `SmartGoalPopup-module__invisible___s8hMS`,
	"col90": `SmartGoalPopup-module__col-90___aYDod`,
	"colAuto": `SmartGoalPopup-module__col-auto___Gqolv`,
	"medicalTabs": `SmartGoalPopup-module__medical-tabs___oZRDW`,
	"medicalTableNew": `SmartGoalPopup-module__medical-table-new___h1n3F`,
	"noPagination": `SmartGoalPopup-module__no-pagination___oJP7x`,
	"medicalTableEmpty": `SmartGoalPopup-module__medical-table-empty___TEf2x`,
	"iconBtn": `SmartGoalPopup-module__icon-btn___DkvlM`,
	"searchIcon": `SmartGoalPopup-module__search-icon___XBYJS`,
	"disableSelect": `SmartGoalPopup-module__disable-select___gzxew`,
	"breakWord": `SmartGoalPopup-module__break-word___Nd_UT`,
	"popupClearBtn": `SmartGoalPopup-module__popup-clear-btn___NymVR`,
	"scrollMB20": `SmartGoalPopup-module__scroll-m-b-20___xAORn`,
	"container": `SmartGoalPopup-module__container___CswUi`,
	"title": `SmartGoalPopup-module__title___ywNw5`,
	"label": `SmartGoalPopup-module__label___sQJTq`,
	"checkboxes": `SmartGoalPopup-module__checkboxes___OKlXb`,
	"checkbox": `SmartGoalPopup-module__checkbox___P30aK`,
	"select": `SmartGoalPopup-module__select___JgXtv`,
	"dates": `SmartGoalPopup-module__dates___wHYQj`,
	"buttonsContainer": `SmartGoalPopup-module__buttonsContainer___Q14MR`,
	"button": `SmartGoalPopup-module__button___N7jST`,
	"buttonsContainerRedesigned": `SmartGoalPopup-module__buttonsContainerRedesigned___fV0tM`
};
module.exports = ___CSS_LOADER_EXPORT___;
